import { Pages } from 'src/constants/metrics';

export const BASE_PATH = '/seller-forums';
export const HOME_PAGE = '/';
export const THREAD_LISTING = '/discussions';
export const NOTIFICATIONS = '/notifications';
export const PREFERENCES = '/preferences';
export const USER_PROFILE_ONBOARDING = '/profile/onboarding';
export const USER_PROFILE = '/profile';
export const getUserProfileDetail = (userId: string) => `${USER_PROFILE}/${userId}`;
export const GROUPS = '/groups';
export const getGroupListing = (groupId: string) => `${GROUPS}/g/${groupId}`;
export const getThreadDetail = (threadId: string) => `${THREAD_LISTING}/t/${threadId}`;
export const THREAD_DETAIL_CREATE = `${THREAD_LISTING}/create`;
export const getThreadDetailEdit = (threadId: string) => `${THREAD_LISTING}/edit/${threadId}`;
export const FAQS = '/faqs';
export const GUIDELINES = '/guidelines';
export const RELEASE_NOTES = '/release-notes';

export const getLoginPage = (redirectPath: string) => `/gp/sign-in/sign-in.html?maxAuthAge=18000&destination=${redirectPath}`;

/**
 * Path to page map used for reporting metrics.
 * Update this map when a new page is added
 */

export const pagePathMap: Record<string, Pages> = {
  [HOME_PAGE]: Pages.home,
  [PREFERENCES]: Pages.preferences,
  [getUserProfileDetail('[userId]')]: Pages.profile,
  [NOTIFICATIONS]: Pages.notifications,
  [FAQS]: Pages.faq,
  [GUIDELINES]: Pages.guidelines,
  [THREAD_LISTING]: Pages.searchListing,
  [THREAD_DETAIL_CREATE]: Pages.createDiscussion,
  [getThreadDetail('[threadId]')]: Pages.threadDetail,
  [getGroupListing('[groupId]')]: Pages.groupListing,
  [RELEASE_NOTES]: Pages.releaseNotes,
  [USER_PROFILE_ONBOARDING]: Pages.userOnboarding,
  [GROUPS]: Pages.groups,
};

export const protectedPages = [
  NOTIFICATIONS,
  USER_PROFILE_ONBOARDING,
  USER_PROFILE,
  `${USER_PROFILE}/`,
  THREAD_DETAIL_CREATE,
  `${THREAD_LISTING}/edit/`,
];
